module.exports = __webpack_public_path__ + "img/sec4_02.0145915e.png";